module.exports = __webpack_public_path__ + "media/bootstrap-icons/layout-three-columns-1bdbeb35.svg";